import script from "./EventParticipants.vue?vue&type=script&setup=true&lang=js"
export * from "./EventParticipants.vue?vue&type=script&setup=true&lang=js"

import "./EventParticipants.vue?vue&type=style&index=0&id=2784a4fd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2784a4fd"]])

export default __exports__